<template>
	<c-modal @close="close" :title="removeText">

		<div>
			<p class="margin-t-32">Weet je zeker dat je deze {{text.toLowerCase()}} definitief wilt {{removeText.toLowerCase()}}?</p>

			<c-button class="c-btn--hollow c-btn--expanded margin-t-32 margin-b-16" @click="remove()">
				Ja, {{text.toLowerCase()}} {{removeText.toLowerCase()}}	
			</c-button>

			<c-button class="c-btn--expanded no-margin-b" @click="close()">
				Nee, {{text.toLowerCase()}} behouden
			</c-button>
		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	components: {
		CModal
	},
	props: {
		text: {
			required: false
		},
		removeText: {
			required: false,
			default: 'Verwijderen'
		}

	},
	methods: {
		close() {
			this.$emit('close');
		},
		remove() {
			this.$emit('remove');
		},
		
	},
}
</script>